'use client';

import React from 'react';
import Link from 'next/link';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';


export default function Header() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-xl border-b border-border shadow-sm">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link href="/homepage" className="flex items-center gap-2.5 group">
          <AppImage
            src="/assets/images/Black-and-Orange-Fitness-Club-Logo-Logo-02-16-2026_12_57_PM-removebg-preview-1771226976236.png"
            alt="VitalityStory Logo"
            width={180}
            height={50}
            className="h-10 w-auto"
          />
          <span className="text-2xl font-serif font-light text-foreground tracking-tight group-hover:text-accent transition-colors">
            VitalityStory
          </span>
        </Link>

        {/* Navigation Menu - Desktop */}
        <nav className="hidden lg:flex items-center gap-8">
          <button 
            onClick={() => scrollToSection('hero')} 
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
          >
            Home
          </button>
          <button 
            onClick={() => scrollToSection('story')} 
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('testimonials')} 
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
          >
            Success Stories
          </button>
          <button 
            onClick={() => scrollToSection('contact')} 
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
          >
            Contact
          </button>
        </nav>

        {/* CTA Button - Desktop */}
        <a
          href="https://3qoXrM.short.gy/8E4z28"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-accent text-accent-foreground px-6 py-2.5 rounded-full font-semibold text-sm hover:bg-accent-hover hover:shadow-lg transition-all duration-300 shadow-md hover:scale-105 cursor-pointer"
        >
          Learn More
          <Icon name="ArrowRightIcon" size={16} />
        </a>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden bg-accent/10 text-accent p-2.5 rounded-full hover:bg-accent/20 transition-all"
          aria-label="Menu"
          onClick={() => scrollToSection('hero')}
        >
          <Icon name="Bars3Icon" size={20} />
        </button>
      </div>
    </header>
  );
}